import React, { useState } from "react";
import classes from "../homepage/Faq.module.css";
import img from "../../assets/Comet_1.png";
import { ArrowDropDownSharp, ArrowDropUpSharp } from "@material-ui/icons";

const FaQ: React.FC = () => {
  const [open, setOpen] = useState(1);
  return (
    <div className={classes["faq-wrapper"]}>
      <div className={classes["faq-content-wrapper"]}>
        <h1
          className={`${classes["faq-title"]} ${classes["faq-header"]}`}
          data-aos="fade-up"
        >
          FAQ
        </h1>
        <div className={classes["faq-outer-content-wrapper"]}>
          <div
            className={classes["faq-inner-content-wrapper"]}
            onClick={() => {
              if (open === 1) {
                return setOpen(0);
              }
              setOpen(1);
            }}
          >
            <h3
              className={`${classes["faq-title"]} ${classes["title-pink"]}`}
              id={open === 1 ? classes["clicked"] : ""}
            >
              What Is On Your Roadmap?
              {open === 1 ? (
                <ArrowDropDownSharp id={classes["faq-arrow-icon"]} />
              ) : (
                <ArrowDropUpSharp id={classes["faq-arrow-icon"]} />
              )}
            </h3>

            <div>
              {open === 1 && (
                <>
                  <div className={classes["faq-text"]} data-aos="flip-right">
                    Battlemechs, nuff' said.
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className={classes["faq-inner-content-wrapper"]}
            onClick={() => {
              if (open === 2) {
                return setOpen(0);
              }
              setOpen(2);
            }}
          >
            <h3
              className={`${classes["faq-title"]} ${classes["title-pink"]}`}
              id={open === 2 ? classes["clicked"] : ""}
            >
              How Do I Mint Space Kitties?
              {open === 2 ? (
                <ArrowDropDownSharp id={classes["faq-arrow-icon"]} />
              ) : (
                <ArrowDropUpSharp id={classes["faq-arrow-icon"]} />
              )}
            </h3>

            <div>
              {open === 2 && (
                <>
                  <div className={classes["faq-text"]} data-aos="flip-right">
                    You probably already did.
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className={classes["faq-inner-content-wrapper"]}
            onClick={() => {
              if (open === 3) {
                return setOpen(0);
              }
              setOpen(3);
            }}
          >
            <h3
              className={`${classes["faq-title"]} ${classes["title-pink"]}`}
              id={open === 3 ? classes["clicked"] : ""}
            >
              What Inspired You To Make This?
              {open === 3 ? (
                <ArrowDropDownSharp id={classes["faq-arrow-icon"]} />
              ) : (
                <ArrowDropUpSharp id={classes["faq-arrow-icon"]} />
              )}
            </h3>

            <div>
              {open === 3 && (
                <>
                  <div className={classes["faq-text"]} data-aos="flip-right">
                    Space Kitties are cute. Space Kitties are good.
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className={classes["faq-inner-content-wrapper"]}
            onClick={() => {
              if (open === 4) {
                return setOpen(0);
              }
              setOpen(4);
            }}
          >
            <h3
              className={`${classes["faq-title"]} ${classes["title-pink"]}`}
              id={open === 4 ? classes["clicked"] : ""}
            >
              When will the mechs be released?
              {open === 4 ? (
                <ArrowDropDownSharp id={classes["faq-arrow-icon"]} />
              ) : (
                <ArrowDropUpSharp id={classes["faq-arrow-icon"]} />
              )}
            </h3>

            <div>
              {open === 4 && (
                <>
                  <div className={classes["faq-text"]} data-aos="flip-right">
                    The Battle Mechs for the tournament PVP game will be
                    released as a season two NFT collection in February 2022.
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className={classes["faq-inner-content-wrapper"]}
            onClick={() => {
              if (open === 5) {
                return setOpen(0);
              }
              setOpen(5);
            }}
          >
            <h3
              className={`${classes["faq-title"]} ${classes["title-pink"]}`}
              id={open === 5 ? classes["clicked"] : ""}
            >
              What can I win in the arena?
              {open === 5 ? (
                <ArrowDropDownSharp id={classes["faq-arrow-icon"]} />
              ) : (
                <ArrowDropUpSharp id={classes["faq-arrow-icon"]} />
              )}
            </h3>

            <div>
              {open === 5 && (
                <>
                  <div className={classes["faq-text"]} data-aos="flip-right">
                    Within the Kittyverse Arena, Kitties can battle it out with
                    one another to gain superiority over the others
                    participating. By winning in the arena, the champion will be
                    rewarded in a bounty of (SOL and $PACE).
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className={classes["faq-inner-content-wrapper"]}
            onClick={() => {
              if (open === 6) {
                return setOpen(0);
              }
              setOpen(6);
            }}
          >
            <h3
              className={`${classes["faq-title"]} ${classes["title-pink"]}`}
              id={open === 6 ? classes["clicked"] : ""}
            >
              What Rights Do I Have To The Artwork?
              {open === 6 ? (
                <ArrowDropDownSharp id={classes["faq-arrow-icon"]} />
              ) : (
                <ArrowDropUpSharp id={classes["faq-arrow-icon"]} />
              )}
            </h3>

            <div>
              {open === 6 && (
                <>
                  <div className={classes["faq-text"]} data-aos="flip-right">
                    You are free to do with your Space Kitty as your heart
                    desires.
                    <br />
                    By purchasing a Space Kitty, you are granted full and
                    complete rights to do whatever you want with your NFT and
                    the artwork included, commercially or otherwise.
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <img className={classes["comet3"]} src={img} alt="" />
      <img className={classes["comet4"]} src={img} alt="" />
    </div>
  );
};

export default FaQ;
